<template>
  <div>
    <v-row>
      <h1 class="ml-4">Products</h1>
    </v-row>
    <v-carousel
      :dark="$vuetify.theme.dark"
      :light="!$vuetify.theme.dark"
      hide-delimiter-background
      height="320"
      class="card-slider reduce-zoom"
      show-arrows-on-hover
    >
      <v-carousel-item>
        <v-row class="mt-2">
          <v-col>
            <total-products-statistics-card />
          </v-col>
          <v-col>
            <total-investment-products-statistics-card />
          </v-col>
          <v-col>
            <total-short-term-insurance-commercial-products-stats-card />
            <!-- <product-categories-per-user /> -->
          </v-col>
        </v-row>
      </v-carousel-item>
      <v-carousel-item>
        <v-row class="mt-2">
          <v-col>
            <total-short-term-personal-products-stats-card />
          </v-col>
          <v-col>
            <total-life-insurance-products-stats-card />
          </v-col>
          <v-col>
            <total-gap-products-stats-card />
          </v-col>
        </v-row>
      </v-carousel-item>
      <v-row class="mt-2">
        <v-col>
          <total-medical-aid-products-stats-card />
        </v-col>
        <v-col>
          <total-short-term-products-stats-card />
        </v-col>
        <v-col>
          <total-loyalty-program-products-stats-card />
        </v-col>
      </v-row>
      <v-carousel-item> </v-carousel-item>
    </v-carousel>

    <v-spacer></v-spacer>
    <v-card class="mt-3">
      <v-card-title>
        <v-autocomplete
          v-model="search"
          :items="products.records"
          item-text="name"
          append-icon="mdi-magnify"
          :loading="isLoading"
          :disabled="isLoading"
          small-chips
          label="Search for a product by name..."
          outlined
          clearable
        ></v-autocomplete>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="products.records"
          :loading="isLoading"
          :search="search"
          transition="scale-transition"
          class="new-detault-table product-view"
        >
          <template v-slot:top>
            <!-- <v-toolbar flat> -->
            <!-- <v-toolbar-title
                ><h4 class="text-md-h4 primary--text">
                  Products
                </h4></v-toolbar-title> -->
            <!-- <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer> -->
            <!-- <v-spacer></v-spacer> -->

            <v-row class="card-slider mb-4" justify="center">
              <v-col cols="12" sm="4" md="4" lg="4">
                <v-dialog v-model="dialog" max-width="900px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      xclass="mx-2"
                      color="blue"
                      large
                      dark
                      v-bind="attrs"
                      v-on="on"
                      ><h1>Bulk Product Upload</h1></v-btn
                    >
                  </template>

                  <v-card>
                    <v-card-title>
                      <span class="text-h1">Bulk Product Upload</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container> <base-product-bulk-create /> </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4">
                <v-btn
                  xclass="mt-2"
                  color="primary"
                  large
                  @click="$router.push('/admin/product/0/edit')"
                >
                  <h1>New Product</h1>
                  <v-icon right> mdi-plus </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4">
                <download-excel
                  :data="products.records"
                  :fields="fields"
                  worksheet="Products"
                  name="rebaseGroupCRMProductsList.xls"
                >
                  <v-btn color="#0a2752" large dark>
                    <h1>Download</h1>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-row>

            <v-spacer />

            <!-- </v-toolbar> -->
          </template>
          <!-- <template v-slot:item.featurePicture="{ item }">
            <v-row justify="space-around">
              <v-avatar v-if="item.featurePicture" tile>
                <v-img
                  :src="item.featurePicture"
                  contain
                  alt="product"
                  color="teal"
                  size="120"
                />
              </v-avatar>
              <v-avatar v-else tile>
                <v-img
                  :src="defaultProfileImage()"
                  contain
                  alt="Insurer"
                  color="teal"
                  size="120"
                />
              </v-avatar>
            </v-row>
          </template> -->
          <template v-slot:item.serial="{ item }">
            <h4 color="primary">
              <router-link :to="'/admin/product/' + item.id">{{
                item.serial
              }}</router-link>
            </h4>
          </template>
          <template v-slot:item.type="{ item }">
            <v-chip label dark>{{ item.type.toUpperCase() }}</v-chip>
          </template>
          <template v-slot:item.createdAt="{ item }">
            <p>
              <span>Created At:</span>
              <span color="primary">{{
                item.createdAt | getFormattedDate
              }}</span>
            </p>
            <p>
              <span color="primary">Updated At:</span>
              <span color="primary">{{
                item.updatedAt | getFormattedDate
              }}</span>
            </p>
          </template>
          <template v-slot:item.price="{ item }">
            <h3 color="primary">R {{ item.price ? item.price : "0" }}</h3>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              fab
              x-small
              dark
              class="mr-2"
              @click="editItem(item)"
              color="primary"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              fab
              x-small
              dark
              class="ml-2"
              @click="deleteItem(item)"
              color="blue darken-2"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
// import defaultProfile from "../../../assets/img/avatar.png";
// import TotalProductsStatisticsCard from "../../../components/Base/StatsCards/TotalProductsStatisticCard.vue";
// import TotalInvestmentProductsStatisticsCard from "../../../components/Base/StatsCards/TotalInvestmentProductsStatsCard copy.vue";
// import AveragePremiumCard from "../../../components/Base/StatsCards/AveragePremiumCard.vue";
// import TotalShortTermInsuranceCommercialProductsStatsCard from "../../../components/Base/StatsCards/TotalShortTermInsuranceCommercialProductsStatsCard.vue";
// import TotalShortTermPersonalProductsStatsCard from "../../../components/Base/StatsCards/TotalShortTermPersonalProductsStatsCard.vue";
// import TotalLifeInsuranceProductsStatsCard from "../../../components/Base/StatsCards/TotalLifeInsuranceProductsStatsCard.vue";
// import TotalGapProductsStatsCard from "../../../components/Base/StatsCards/TotalGapProductsStatsCard.vue";
// import TotalMedicalAidProductsStatsCard from "../../../components/Base/StatsCards/TotalMedicalAidProductsStatsCard.vue";
// import TotalShortTermProductsStatsCard from "../../../components/Base/StatsCards/TotalShortTermProductsStatsCard.vue";
// import TotalLoyaltyProgramProductsStatsCard from "../../../components/Base/StatsCards/TotalLoyaltyProgramProductsStatsCard.vue";
// import ProductCategoriesPerUser from "../../../components/Base/ProductCategoriesPerUserGraph.vue";

// import { mapState } from 'vuex'
export default {
  components: {
    // TotalProductsStatisticsCard,
    // TotalInvestmentProductsStatisticsCard,
    // // defaultProfile,
    // AveragePremiumCard,
    // TotalShortTermInsuranceCommercialProductsStatsCard,
    // TotalShortTermPersonalProductsStatsCard,
    // TotalLifeInsuranceProductsStatsCard,
    // TotalGapProductsStatsCard,
    // TotalMedicalAidProductsStatsCard,
    // TotalShortTermProductsStatsCard,
    // TotalLoyaltyProgramProductsStatsCard,
    // ProductCategoriesPerUser,
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Description", value: "description" },
        { text: "Category", value: "category" },
        { text: "Insurer", value: "insurerName" },
        { text: "price", value: "price" },
        { text: "Date", value: "createdAt" },
        { text: "Actions", align: "right", sortable: false, value: "actions" },
      ],
      search: "",
      products: [],
      dialog: false,
      totalRecords: 0,
      isLoading: false,
      fields: {
        "Product Name": "name",
        "Product Description": "description",
        "Product Category": "category",
        Insurer: "insurer",
        Price: "price",
        "Created At": "createdAt",
      },
    };
  },

  apollo: {
    products: {
      query: gql`
        query Products($limit: Int!, $skip: Int!, $query: JSON!) {
          products(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              name
              description
              category
              insurer
              insurerName
              # featurePicture
              price
              documents {
                id
              }
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const self = this;
        const limit = 9999;
        const skip = 0;
        return {
          limit: limit,
          skip: skip,
          query: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
  },

  methods: {
    editItem(item) {
      this.$router.push(`/admin/product/${item.id}/edit`);
    },
    // defaultProfileImage() {
    //   return defaultProfile;
    // },
    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deleteProduct(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: {
                id: item.id,
              },
            });

            if (response) {
              this.$swal(
                "Success!",
                "Product was successfully deleted",
                "success"
              );
              this.$router.go(this.$route.currentRoute);
            }
          } catch (e) {
            console.log(`Deletion Failed ${JSON.stringify(e)}`);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
